import { API_BASE } from './api';

const KEY = 'hc_admin_token';

export const getToken = () => {
  try { return localStorage.getItem(KEY); } catch { return null; }
};

const setToken = (t) => {
  try {
    if (t) localStorage.setItem(KEY, t);
    else localStorage.removeItem(KEY);
  } catch { /* ignore */ }
};

export const isAdminAuthed = () => !!getToken();

export const clearAuth = () => setToken(null);

/** Sign in against the real Auth service (via the HolaCaribe API proxy). */
export async function signInWithApi(email, password) {
  const res = await fetch(`${API_BASE}/api/admin/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });
  if (!res.ok) {
    const msg = res.status === 401 ? 'Invalid email or password.' : 'Sign-in failed, please try again.';
    throw new Error(msg);
  }
  const data = await res.json();
  if (!data?.token) throw new Error('Sign-in failed, please try again.');
  setToken(data.token);
  return data.user;
}

/** Log out both locally and on the Auth service. */
export async function signOutWithApi() {
  const token = getToken();
  clearAuth();
  if (!token) return;
  try {
    await fetch(`${API_BASE}/api/admin/logout`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch { /* best effort */ }
}
